<!--  -->
<template>
  <div class="content">
    <div class="header" :class="one == 1 ? 'one' : 'color'">{{ text }}</div>
    <img v-if="one == 1" src="../assets/about/Shape.png" alt="" />
    <img v-else src="../assets/servie/line.png" alt="" />
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["text", "one"],
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.header {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.color {
  color: #333333;
}
.one {
  color: #eee;
}
img {
  width: 112px;
  margin-left: 50%;
  transform: translateX(-50%);
  padding-top: 20px;
}
@screen-lg-min: 768px;
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  .header {
    font-size: 30px;
  }
}
@screen-sm-min: 414px;
/* 手机（等于 375px） */
@media (max-width: @screen-sm-min) {
  .header {
    font-size: 15px;
  }
  img{
    display: none;
  }
}
</style>